import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { MuiNumberField } from "../../../../components/formsComponents/MuiNumberField";
import { FieldLabel } from "../components/FieldLabel";
import { ACCENT } from "../BusinessOnboard.constant";

interface IOtpStepProps {
  otp: string;
  otpError: string | null;
  resendTimer: number;
  loading: boolean;
  onOtpChange: (value: string) => void;
  onResend: () => void;
}

/**
 * Step 0b — OTP entry. The "Verify & continue" primary button lives in the
 * shared StepFooter (owned by the container). The masked number is shown in
 * the step header subtitle, so no separate "OTP sent to" box is needed.
 */
export const OtpStep: React.FC<IOtpStepProps> = ({
  otp,
  otpError,
  resendTimer,
  loading,
  onOtpChange,
  onResend,
}) => {
  return (
    <Stack spacing={2.5}>
      <Box>
        <FieldLabel label="6-digit OTP" />
        <MuiNumberField
          name="otp"
          placeholder="Enter the code"
          value={otp}
          onChange={(e) => onOtpChange(e.target.value.slice(0, 6))}
          error={otpError || ""}
          sx={{
            "& .MuiInputBase-root": {
              minHeight: 48,
              borderRadius: "10px",
            },
          }}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
          Didn't receive it?
        </Typography>
        {resendTimer > 0 ? (
          <Typography sx={{ fontSize: "0.85rem", fontWeight: 600 }}>
            Resend in {resendTimer}s
          </Typography>
        ) : (
          <Typography
            component="span"
            onClick={loading ? undefined : onResend}
            sx={{
              fontSize: "0.85rem",
              fontWeight: 700,
              color: ACCENT.main,
              cursor: loading ? "default" : "pointer",
              "&:hover": { textDecoration: loading ? "none" : "underline" },
            }}
          >
            Resend code
          </Typography>
        )}
      </Box>
    </Stack>
  );
};
